var W = Object.defineProperty;
var K = (n, t, e) =>
  t in n
    ? W(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e })
    : (n[t] = e);
var f = (n, t, e) => (K(n, typeof t != 'symbol' ? t + '' : t, e), e);
function X() {
  var n =
    !navigator.userAgentData &&
    /Safari\//.test(navigator.userAgent) &&
    !/Chrom(e|ium)\//.test(navigator.userAgent);
  if (!n || !indexedDB.databases) return Promise.resolve();
  var t;
  return new Promise(function (e) {
    var r = function () {
      return indexedDB.databases().finally(e);
    };
    (t = setInterval(r, 100)), r();
  }).finally(function () {
    return clearInterval(t);
  });
}
function T(n) {
  return new Promise((t, e) => {
    (n.oncomplete = n.onsuccess = () => t(n.result)),
      (n.onabort = n.onerror = () => e(n.error));
  });
}
function Z(n, t) {
  const e = X().then(() => {
    const r = indexedDB.open(n);
    return (r.onupgradeneeded = () => r.result.createObjectStore(t)), T(r);
  });
  return (r, a) => e.then((c) => a(c.transaction(t, r).objectStore(t)));
}
let E;
function B() {
  return E || (E = Z('keyval-store', 'keyval')), E;
}
function Y(n, t = B()) {
  return t('readonly', (e) => T(e.get(n)));
}
function Q(n, t, e = B()) {
  return e('readwrite', (r) => (r.put(t, n), T(r.transaction)));
}
function ee(n, t = B()) {
  return t('readwrite', (e) => (e.delete(n), T(e.transaction)));
}
let te = () => '';
const ne = () => te(),
  re = (n, t, ...e) => {
    typeof e[0] == 'string'
      ? t.call(console, `${n.namespace}: ${e[0]}`, ...e.slice(1))
      : t.call(console, `${n.namespace}:`, ...e);
  };
function oe(n, t) {
  return t.bind(console);
}
function P(n, t, e) {
  return (...r) => {
    re(n, t, ...r);
  };
}
function w(n, t, e) {
  return (...r) => {
    n.debugLoggers[e](...r);
  };
}
function se(n, t) {
  return (...e) => {
    e.length > 1
      ? t.call(console, e[0], `${n.namespace}: ${e[1]}`, ...e.slice(2))
      : e.length === 1 && t.call(console, e[0], n.namespace);
  };
}
const ae = {
    log: w,
    warn: w,
    error: w,
    info: w,
    debug: w,
    time: P,
    timeEnd: P,
    timeLog: P,
    assert: se,
  },
  ie = (n, t, e) => {
    const r = (ae[t] ?? oe)(n, console[t], t);
    return (...a) => {
      for (const c of e) c(n, t, ...a);
      r(...a);
    };
  };
function ce(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, 'default')
    ? n.default
    : n;
}
var U = { exports: {} },
  I,
  N;
function ue() {
  if (N) return I;
  N = 1;
  var n = 1e3,
    t = n * 60,
    e = t * 60,
    r = e * 24,
    a = r * 7,
    c = r * 365.25;
  I = function (o, s) {
    s = s || {};
    var i = typeof o;
    if (i === 'string' && o.length > 0) return d(o);
    if (i === 'number' && isFinite(o)) return s.long ? u(o) : l(o);
    throw new Error(
      'val is not a non-empty string or a valid number. val=' +
        JSON.stringify(o),
    );
  };
  function d(o) {
    if (((o = String(o)), !(o.length > 100))) {
      var s =
        /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
          o,
        );
      if (s) {
        var i = parseFloat(s[1]),
          m = (s[2] || 'ms').toLowerCase();
        switch (m) {
          case 'years':
          case 'year':
          case 'yrs':
          case 'yr':
          case 'y':
            return i * c;
          case 'weeks':
          case 'week':
          case 'w':
            return i * a;
          case 'days':
          case 'day':
          case 'd':
            return i * r;
          case 'hours':
          case 'hour':
          case 'hrs':
          case 'hr':
          case 'h':
            return i * e;
          case 'minutes':
          case 'minute':
          case 'mins':
          case 'min':
          case 'm':
            return i * t;
          case 'seconds':
          case 'second':
          case 'secs':
          case 'sec':
          case 's':
            return i * n;
          case 'milliseconds':
          case 'millisecond':
          case 'msecs':
          case 'msec':
          case 'ms':
            return i;
          default:
            return;
        }
      }
    }
  }
  function l(o) {
    var s = Math.abs(o);
    return s >= r
      ? Math.round(o / r) + 'd'
      : s >= e
      ? Math.round(o / e) + 'h'
      : s >= t
      ? Math.round(o / t) + 'm'
      : s >= n
      ? Math.round(o / n) + 's'
      : o + 'ms';
  }
  function u(o) {
    var s = Math.abs(o);
    return s >= r
      ? p(o, s, r, 'day')
      : s >= e
      ? p(o, s, e, 'hour')
      : s >= t
      ? p(o, s, t, 'minute')
      : s >= n
      ? p(o, s, n, 'second')
      : o + ' ms';
  }
  function p(o, s, i, m) {
    var v = s >= i * 1.5;
    return Math.round(o / i) + ' ' + m + (v ? 's' : '');
  }
  return I;
}
function le(n) {
  (e.debug = e),
    (e.default = e),
    (e.coerce = u),
    (e.disable = c),
    (e.enable = a),
    (e.enabled = d),
    (e.humanize = ue()),
    (e.destroy = p),
    Object.keys(n).forEach((o) => {
      e[o] = n[o];
    }),
    (e.names = []),
    (e.skips = []),
    (e.formatters = {});
  function t(o) {
    let s = 0;
    for (let i = 0; i < o.length; i++)
      (s = (s << 5) - s + o.charCodeAt(i)), (s |= 0);
    return e.colors[Math.abs(s) % e.colors.length];
  }
  e.selectColor = t;
  function e(o) {
    let s,
      i = null,
      m,
      v;
    function C(...b) {
      if (!C.enabled) return;
      const y = C,
        _ = Number(/* @__PURE__ */ new Date()),
        q = _ - (s || _);
      (y.diff = q),
        (y.prev = s),
        (y.curr = _),
        (s = _),
        (b[0] = e.coerce(b[0])),
        typeof b[0] != 'string' && b.unshift('%O');
      let k = 0;
      (b[0] = b[0].replace(/%([a-zA-Z%])/g, (D, J) => {
        if (D === '%%') return '%';
        k++;
        const $ = e.formatters[J];
        if (typeof $ == 'function') {
          const H = b[k];
          (D = $.call(y, H)), b.splice(k, 1), k--;
        }
        return D;
      })),
        e.formatArgs.call(y, b),
        (y.log || e.log).apply(y, b);
    }
    return (
      (C.namespace = o),
      (C.useColors = e.useColors()),
      (C.color = e.selectColor(o)),
      (C.extend = r),
      (C.destroy = e.destroy),
      Object.defineProperty(C, 'enabled', {
        enumerable: !0,
        configurable: !1,
        get: () =>
          i !== null
            ? i
            : (m !== e.namespaces && ((m = e.namespaces), (v = e.enabled(o))),
              v),
        set: (b) => {
          i = b;
        },
      }),
      typeof e.init == 'function' && e.init(C),
      C
    );
  }
  function r(o, s) {
    const i = e(this.namespace + (typeof s > 'u' ? ':' : s) + o);
    return (i.log = this.log), i;
  }
  function a(o) {
    e.save(o), (e.namespaces = o), (e.names = []), (e.skips = []);
    let s;
    const i = (typeof o == 'string' ? o : '').split(/[\s,]+/),
      m = i.length;
    for (s = 0; s < m; s++)
      i[s] &&
        ((o = i[s].replace(/\*/g, '.*?')),
        o[0] === '-'
          ? e.skips.push(new RegExp('^' + o.substr(1) + '$'))
          : e.names.push(new RegExp('^' + o + '$')));
  }
  function c() {
    const o = [...e.names.map(l), ...e.skips.map(l).map((s) => '-' + s)].join(
      ',',
    );
    return e.enable(''), o;
  }
  function d(o) {
    if (o[o.length - 1] === '*') return !0;
    let s, i;
    for (s = 0, i = e.skips.length; s < i; s++)
      if (e.skips[s].test(o)) return !1;
    for (s = 0, i = e.names.length; s < i; s++)
      if (e.names[s].test(o)) return !0;
    return !1;
  }
  function l(o) {
    return o
      .toString()
      .substring(2, o.toString().length - 2)
      .replace(/\.\*\?$/, '*');
  }
  function u(o) {
    return o instanceof Error ? o.stack || o.message : o;
  }
  function p() {
    console.warn(
      'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.',
    );
  }
  return e.enable(e.load()), e;
}
var de = le;
(function (n, t) {
  (t.formatArgs = r),
    (t.save = a),
    (t.load = c),
    (t.useColors = e),
    (t.storage = d()),
    (t.destroy = /* @__PURE__ */ (() => {
      let u = !1;
      return () => {
        u ||
          ((u = !0),
          console.warn(
            'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.',
          ));
      };
    })()),
    (t.colors = [
      '#0000CC',
      '#0000FF',
      '#0033CC',
      '#0033FF',
      '#0066CC',
      '#0066FF',
      '#0099CC',
      '#0099FF',
      '#00CC00',
      '#00CC33',
      '#00CC66',
      '#00CC99',
      '#00CCCC',
      '#00CCFF',
      '#3300CC',
      '#3300FF',
      '#3333CC',
      '#3333FF',
      '#3366CC',
      '#3366FF',
      '#3399CC',
      '#3399FF',
      '#33CC00',
      '#33CC33',
      '#33CC66',
      '#33CC99',
      '#33CCCC',
      '#33CCFF',
      '#6600CC',
      '#6600FF',
      '#6633CC',
      '#6633FF',
      '#66CC00',
      '#66CC33',
      '#9900CC',
      '#9900FF',
      '#9933CC',
      '#9933FF',
      '#99CC00',
      '#99CC33',
      '#CC0000',
      '#CC0033',
      '#CC0066',
      '#CC0099',
      '#CC00CC',
      '#CC00FF',
      '#CC3300',
      '#CC3333',
      '#CC3366',
      '#CC3399',
      '#CC33CC',
      '#CC33FF',
      '#CC6600',
      '#CC6633',
      '#CC9900',
      '#CC9933',
      '#CCCC00',
      '#CCCC33',
      '#FF0000',
      '#FF0033',
      '#FF0066',
      '#FF0099',
      '#FF00CC',
      '#FF00FF',
      '#FF3300',
      '#FF3333',
      '#FF3366',
      '#FF3399',
      '#FF33CC',
      '#FF33FF',
      '#FF6600',
      '#FF6633',
      '#FF9900',
      '#FF9933',
      '#FFCC00',
      '#FFCC33',
    ]);
  function e() {
    return typeof window < 'u' &&
      window.process &&
      (window.process.type === 'renderer' || window.process.__nwjs)
      ? !0
      : typeof navigator < 'u' &&
        navigator.userAgent &&
        navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)
      ? !1
      : (typeof document < 'u' &&
          document.documentElement &&
          document.documentElement.style &&
          document.documentElement.style.WebkitAppearance) || // Is firebug? http://stackoverflow.com/a/398120/376773
        (typeof window < 'u' &&
          window.console &&
          (window.console.firebug ||
            (window.console.exception && window.console.table))) || // Is firefox >= v31?
        // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
        (typeof navigator < 'u' &&
          navigator.userAgent &&
          navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) &&
          parseInt(RegExp.$1, 10) >= 31) || // Double check webkit in userAgent just in case we are in a worker
        (typeof navigator < 'u' &&
          navigator.userAgent &&
          navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
  }
  function r(u) {
    if (
      ((u[0] =
        (this.useColors ? '%c' : '') +
        this.namespace +
        (this.useColors ? ' %c' : ' ') +
        u[0] +
        (this.useColors ? '%c ' : ' ') +
        '+' +
        n.exports.humanize(this.diff)),
      !this.useColors)
    )
      return;
    const p = 'color: ' + this.color;
    u.splice(1, 0, p, 'color: inherit');
    let o = 0,
      s = 0;
    u[0].replace(/%[a-zA-Z%]/g, (i) => {
      i !== '%%' && (o++, i === '%c' && (s = o));
    }),
      u.splice(s, 0, p);
  }
  t.log = console.debug || console.log || (() => {});
  function a(u) {
    try {
      u ? t.storage.setItem('debug', u) : t.storage.removeItem('debug');
    } catch {}
  }
  function c() {
    let u;
    try {
      u = t.storage.getItem('debug');
    } catch {}
    return (
      !u && typeof process < 'u' && 'env' in process && (u = process.env.DEBUG),
      u
    );
  }
  function d() {
    try {
      return localStorage;
    } catch {}
  }
  n.exports = de(t);
  const { formatters: l } = n.exports;
  l.j = function (u) {
    try {
      return JSON.stringify(u);
    } catch (p) {
      return '[UnexpectedJSONParseError]: ' + p.message;
    }
  };
})(U, U.exports);
var he = U.exports;
const F = /* @__PURE__ */ ce(he);
class fe {
  constructor(t, e) {
    f(this, 'options');
    f(this, 'namespace');
    f(this, 'color');
    f(this, 'debugLoggers');
    (this.namespace = t), (this.options = Object.freeze({ ...e }));
    const r = F(t);
    (this.debugLoggers = {
      warn: F(t),
      error: F(t),
      log: F(t),
      info: F(t),
      /*
        TODO: at somepoint in the future we will want to separate the debug
              logger so that we can prevent uploads of debug level logs to UV
      */
      debug: r,
    }),
      (this.color = r.color),
      Object.entries(this.debugLoggers).forEach(([a, c]) => {
        (c.log = console[a].bind(console)),
          (c.color = this.color),
          (c.enabled = !0);
      });
  }
  getChild(t, e) {
    return G(`${this.namespace}:${t}`, {
      ...this.options,
      ...e,
    });
  }
}
let L = [];
const ge = 5e3,
  pe = (n) => {
    L.push(n);
  },
  M = () => L.splice(0),
  be = () => L.length >= ge,
  Ce = {
    log: 'LOG',
    warn: 'WARN',
    error: 'ERROR',
    info: 'INFO',
  },
  me = (n) => Ce[n] ?? 'UNKNOWN',
  ye = 'undefined',
  we = /* @__PURE__ */ new Set([
    'string',
    'number',
    'boolean',
    'bigint',
    'symbol',
  ]),
  Fe = (n) => {
    if (n instanceof Error) return n.message.toString();
    if (we.has(typeof n)) return n.toString();
    if (n === null) return 'null';
    if (Array.isArray(n)) return `Array[${n.length}]`;
    if (n instanceof Object)
      try {
        return JSON.stringify(n);
      } catch {
        return `Object{${Object.keys(n).join(', ')}}`;
      }
    return ye;
  },
  Se = (n) => n.map(Fe).join(' ');
function ve(n, ...t) {
  const e = {
    t: /* @__PURE__ */ new Date().toISOString(),
    l: n.level,
    ns: n.namespace,
    c: n.color,
    w: window.name,
    log: '',
  };
  return t.length === 0 || (e.log = Se(t)), e;
}
const _e = /* @__PURE__ */ new Set(['log', 'warn', 'error', 'info']);
function ke(n, t, ...e) {
  if (_e.has(t)) {
    const r = ve(
      {
        level: me(t),
        namespace: n.namespace,
        color: n.color,
      },
      ...e,
    );
    return pe(r), r;
  }
}
var A,
  Ae = new Uint8Array(16);
function Te() {
  if (
    !A &&
    ((A =
      (typeof crypto < 'u' &&
        crypto.getRandomValues &&
        crypto.getRandomValues.bind(crypto)) ||
      (typeof msCrypto < 'u' &&
        typeof msCrypto.getRandomValues == 'function' &&
        msCrypto.getRandomValues.bind(msCrypto))),
    !A)
  )
    throw new Error(
      'crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported',
    );
  return A(Ae);
}
const De =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Ee(n) {
  return typeof n == 'string' && De.test(n);
}
var g = [];
for (var R = 0; R < 256; ++R) g.push((R + 256).toString(16).substr(1));
function Pe(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0,
    e = (
      g[n[t + 0]] +
      g[n[t + 1]] +
      g[n[t + 2]] +
      g[n[t + 3]] +
      '-' +
      g[n[t + 4]] +
      g[n[t + 5]] +
      '-' +
      g[n[t + 6]] +
      g[n[t + 7]] +
      '-' +
      g[n[t + 8]] +
      g[n[t + 9]] +
      '-' +
      g[n[t + 10]] +
      g[n[t + 11]] +
      g[n[t + 12]] +
      g[n[t + 13]] +
      g[n[t + 14]] +
      g[n[t + 15]]
    ).toLowerCase();
  if (!Ee(e)) throw TypeError('Stringified UUID is invalid');
  return e;
}
function Ie(n, t, e) {
  n = n || {};
  var r = n.random || (n.rng || Te)();
  return (r[6] = (r[6] & 15) | 64), (r[8] = (r[8] & 63) | 128), Pe(r);
}
const Re = (n) => {
  if (!navigator.sendBeacon) return !1;
  const { headers: t = {}, data: e, beaconUrl: r, queryParams: a } = n,
    c = `${r}?${a}`,
    d = `{
    "headers": ${JSON.stringify(t)},
    "log": ${e}
  }`,
    l = new Blob([d], { type: 'application/json' });
  return navigator.sendBeacon(c, l);
};
async function Oe(n) {
  const { uploadUrl: t, queryParams: e, headers: r, data: a } = n,
    c = ne(),
    d = Object.assign({}, r, {
      'Content-Type': 'application/json',
      Authorization: c,
    });
  return {
    url: `${t}?${e}`,
    options: {
      headers: d,
      body: a,
      method: 'POST',
    },
  };
}
async function Ue(n) {
  const { url: t, options: e } = await Oe(n);
  return fetch(t, e);
}
const Be = '/api/applog/',
  Le = '/api/applogbeacon/',
  $e = (n) => n === 'error',
  j = async (n, t) => {
    const e = new URLSearchParams(t).toString();
    try {
      await Ue({
        uploadUrl: `${n}${Be}`,
        data: JSON.stringify(M()),
        queryParams: e,
      });
    } catch (r) {
      console.error('Failed to upload logs, error:', r);
    }
  },
  Ne = (n) => {
    const t = new URLSearchParams(n).toString();
    return Re({
      beaconUrl: Le,
      data: JSON.stringify(M()),
      queryParams: t,
    });
  },
  je = Ie();
async function xe(n, t) {
  const e = {
    type: 'web-dp2',
    tab: 'TODO_TAB_ID',
    // TODO (infra-2253): implement tabId
    device: 'TODO_DEVICE_ID',
    // TODO (infra-2254): implement deviceId
    client_instance: je,
    // TODO (infra-2252): expose this as a util
  };
  return (
    $e(t) &&
      (await j(n.options.apiBaseURL, {
        ...e,
        sub_type: 'unexpected_console_error',
      })),
    be() &&
      (await j(n.options.apiBaseURL, {
        ...e,
        sub_type: 'log_buffer_full',
      })),
    !0
  );
}
const Me = () => {
  window.addEventListener(
    'pagehide',
    () => {
      Ne({ sub_type: 'pagehide' });
    },
    !1,
  );
};
Me();
const ze = [ke, xe];
var Ge = {
  BASE_URL: '/',
  MODE: 'production',
  DEV: !1,
  PROD: !0,
  SSR: !1,
  DP_BUILD_APP_VERSION: '1.4.0',
};
const z = [...ze],
  Ve = (n) => {
    z.push(n);
  };
function G(n, t = {}) {
  if (n.length === 0) throw new Error('please provide a namespace.');
  const e =
      (t.apiBaseURL && t.apiBaseURL.length > 0
        ? t.apiBaseURL
        : Ge.DP_BUILD_UV_HTTP_URL) || '',
    r = new fe(n, {
      ...t,
      apiBaseURL: e,
    }),
    a = {},
    c = (l) => {
      if (a[l]) return a[l];
      const u = ie(r, l, z);
      return (a[l] = u), u;
    },
    d = (l) => {
      if (l === 'registerMiddleware') return Ve;
      if (l in r) return r[l];
      const u = console[l];
      return typeof u == 'function' ? c(l) : u;
    };
  return new Proxy(Function.prototype, {
    get: (l, u) => d(u),
    apply: (l, u, p) => {
      d('log')(...p);
    },
  });
}
const V = G('auth'),
  h = V.getChild('auth-controller'),
  O = 'authData';
class We {
  constructor() {
    f(this, 'authState', {
      data: !1,
      fetching: !0,
      error: null,
      failed: !1,
      userData: null,
    });
    f(this, 'accessToken', null);
    f(this, 'subscribers', []);
    f(this, 'abortController', null);
    f(this, 'fetchingPromise', null);
    f(this, 'idbPromise', null);
    f(this, 'authData', null);
    f(this, 'config', null);
    this.getAuthDataFromIDB();
  }
  setConfig(t) {
    h.debug('Setting config', t), (this.config = t);
  }
  notifySubscribers() {
    h.log('Notifying subscribers'),
      this.subscribers.forEach((t) => {
        t(this.getAuthState());
      });
  }
  // method should be reworked after refresh token introduced
  async fetchAuthState() {
    var t;
    if (!this.config) throw new Error('AuthController is not configured');
    h.log('Fetching auth state'),
      (this.abortController = new AbortController());
    try {
      (this.authData = await this.config.fetchAuthData({
        abortController: this.abortController,
      })),
        (this.accessToken = this.authData.accessToken),
        (this.authState = {
          ...this.authState,
          fetching: !1,
          data: !0,
          error: null,
          failed: !1,
          userData:
            ((t = this.authData.idToken) == null ? void 0 : t.user) ?? null,
        }),
        h.log('Auth state fetched');
    } catch (e) {
      const r =
        e instanceof Error
          ? e
          : new Error((e == null ? void 0 : e.toString()) ?? 'Unknown error');
      throw (
        ((this.authState = {
          ...this.authState,
          fetching: !1,
          error: r,
          failed: !0,
        }),
        h.log('Error fetching auth state', r),
        e)
      );
    }
  }
  subscribeToAuthState(t) {
    return (
      h.log('Subscribing to auth state'),
      this.subscribers.push(t),
      () => {
        this.subscribers = this.subscribers.filter((e) => e !== t);
      }
    );
  }
  async updateAuthState() {
    if ((h.log('Updating auth state'), this.fetchingPromise))
      return this.fetchingPromise;
    (this.authState.fetching = !0),
      this.notifySubscribers(),
      (this.fetchingPromise = this.fetchAuthState().catch((t) => {
        throw (
          (h.log('Error updating auth state', t),
          (this.authState.fetching = !1),
          this.notifySubscribers(),
          t)
        );
      })),
      await this.fetchingPromise,
      (this.fetchingPromise = null),
      (this.authState.fetching = !1),
      h.log('Auth state updated'),
      this.notifySubscribers();
  }
  async signOut() {
    var e;
    h.log('Signing out'),
      (e = this.abortController) == null || e.abort(),
      (this.fetchingPromise = null),
      await ee(O),
      (this.authState = {
        ...this.authState,
        data: !1,
        fetching: !1,
        error: null,
        failed: !1,
        userData: null,
      }),
      (this.accessToken = null);
    const t = this.authData;
    return (this.authData = null), t ?? { accessToken: '' };
  }
  getToken() {
    if ((h.debug('Getting token'), !this.accessToken))
      throw this.authState.fetching
        ? new Error('Too early to get token, fetching in progress')
        : new Error('Access token is not set. Not Authorized');
    return this.accessToken;
  }
  getAuthState() {
    return (
      h.debug('Getting auth state'),
      {
        ...this.authState,
      }
    );
  }
  /**
   * Method to set dev auth data
   * @param authData
   */
  setAuthData(t) {
    var e, r;
    h.log('Setting auth data'),
      t instanceof Error
        ? (this.authState = {
            ...this.authState,
            fetching: !1,
            data: !1,
            error: t,
            failed: !0,
            userData: null,
          })
        : ((this.authData = t),
          this.saveAuthDataToIDB(t),
          (this.accessToken = `Bearer ${t.accessToken}`),
          (this.authState = {
            ...this.authState,
            fetching: !1,
            data: !0,
            error: null,
            failed: !1,
            // in case user_v2 is not in the scopes
            userData: ((e = t.idToken) == null ? void 0 : e.user) ?? {
              id: ((r = t.idToken) == null ? void 0 : r.sub) ?? '',
            },
          })),
      this.notifySubscribers();
  }
  async saveAuthDataToIDB(t) {
    try {
      return h.log('Saving auth data to idb'), Q(O, t);
    } catch (e) {
      throw (
        (h.warn('Error saving auth data to idb', e),
        new Error(`Error from idb while storing auth data: ${e}`))
      );
    }
  }
  async getAuthDataFromIDB() {
    var t, e;
    try {
      return (
        h.log('Getting auth data from idb'),
        this.idbPromise
          ? this.idbPromise
          : ((this.idbPromise = Y(O)),
            (this.authData = await this.idbPromise),
            (this.idbPromise = null),
            this.authData
              ? (h.log('Auth data fetched from idb'),
                (this.authState = {
                  ...this.authState,
                  fetching: !1,
                  data: !0,
                  // in case user_v2 is not in the scopes
                  userData: ((t = this.authData.idToken) == null
                    ? void 0
                    : t.user) ?? {
                    id:
                      ((e = this.authData.idToken) == null ? void 0 : e.sub) ??
                      '',
                  },
                }),
                (this.accessToken = `Bearer ${this.authData.accessToken}`))
              : (h.log('No auth data in idb'),
                (this.authState = {
                  ...this.authState,
                  fetching: !1,
                  data: !1,
                  userData: null,
                })),
            this.notifySubscribers(),
            this.authData ?? null)
      );
    } catch (r) {
      throw new Error(`Error from idb while getting auth data: ${r}`);
    }
  }
  async waitForIdb() {
    await this.idbPromise;
  }
  async waitForAuthorized() {
    if ((h.debug('Waiting for authorized'), this.authState.data)) return;
    let t;
    const e = new Promise((a) => {
        t = a;
      }),
      r = this.subscribeToAuthState((a) => {
        a.data && (t(), r());
      });
    return e;
  }
}
const S = V.getChild('dp-oauth'),
  x = (n) => {
    const t = new Uint8Array(n);
    return (
      crypto.getRandomValues(t),
      [...t].map((r) => r.toString(16).padStart(2, '0')).join('')
    );
  },
  qe = (n) => {
    const e = n.split('.')[1].replaceAll('-', '+').replaceAll('_', '/'),
      r = atob(e);
    return JSON.parse(r);
  };
class Ke {
  constructor({
    dpBaseUri: t = 'https://dialpad.com',
    clientId: e,
    redirectUri: r,
    scopes: a = 'openid',
  }) {
    f(this, 'dpBaseUri');
    f(this, 'clientId');
    f(this, 'redirectUri');
    f(this, 'scopes');
    (this.dpBaseUri = t),
      (this.clientId = e),
      (this.redirectUri = r),
      (this.scopes = a);
  }
  createAuthorizeUri({
    responseMode: t = 'fragment',
    redirectUri: e = this.redirectUri,
  } = {}) {
    S.debug('Creating authorize URI', e);
    const r = x(32),
      a = x(32),
      c = new URL(`${this.dpBaseUri}/oauth2/authorize`);
    return (
      c.searchParams.append('client_id', this.clientId),
      c.searchParams.append('response_type', 'code'),
      c.searchParams.append('response_mode', t),
      c.searchParams.append('redirect_uri', e),
      c.searchParams.append('state', r),
      c.searchParams.append('scope', this.scopes),
      c.searchParams.append('code_challenge', a),
      c.searchParams.append('code_challenge_method', 'plain'),
      {
        authorizeUri: c.toString(),
        stateToStore: { csrfToken: r, pkceChallenge: a },
      }
    );
  }
  async getToken({ code: t, state: e }, r) {
    S.log('getToken');
    const { csrfToken: a, pkceChallenge: c } = r;
    if (!a || e !== a) throw new Error('Aborting due to CSRF token mismatch');
    const d = await this.tokenRequest('authorization_code', {
        code: t,
        // eslint-disable-next-line camelcase
        code_verifier: c,
      }),
      l = { accessToken: d.access_token };
    return (
      d.refresh_token && (l.refreshToken = d.refresh_token),
      d.expires_in && (l.expiresIn = d.expires_in),
      d.id_token &&
        ((l.idToken = qe(d.id_token)), (l.encodedIdToken = d.id_token)),
      l
    );
  }
  async refreshToken(t) {
    const e = await this.tokenRequest('refresh_token', {
        // eslint-disable-next-line camelcase
        refresh_token: t,
      }),
      r = { accessToken: e.access_token };
    return (
      e.refresh_token && (r.refreshToken = e.refresh_token),
      e.expires_in && (r.expiresIn = e.expires_in),
      r
    );
  }
  async tokenRequest(t, e) {
    S.debug('tokenRequest', t);
    const r = {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      a = new URLSearchParams();
    a.append('client_id', this.clientId), a.append('grant_type', t);
    for (const [d, l] of Object.entries(e)) a.append(d, l);
    const c = await fetch(`${this.dpBaseUri}/oauth2/token`, {
      method: 'POST',
      headers: r,
      body: a,
    });
    if (c.status !== 200)
      throw new Error(`Got HTTP ${c.status} from token endpoint`);
    return await c.json();
  }
  redirectToSignout(t) {
    if (!t.idToken) {
      S.warn('No idToken in authData, skipping signout redirect');
      return;
    }
    S.log('Redirecting to signout');
    const e = `${location.origin}/login`;
    location.href = `${this.dpBaseUri}/oauth2/logout?client_id=${this.clientId}&id_token_hint=${t.encodedIdToken}&post_logout_redirect_uri=${e}`;
  }
}
export { We as AuthController, Ke as DPOAuth };
